var exports = {
  "Nr": "DiscoveryGuildCard.module__card___TWg5Xz",
  "L8": "DiscoveryGuildCard.module__cardButton___TWg5Xz",
  "vK": "DiscoveryGuildCard.module__banner___TWg5Xz",
  "_e": "DiscoveryGuildCard.module__bannerImage___TWg5Xz",
  "Dw": "DiscoveryGuildCard.module__bannerScrim___TWg5Xz",
  "Kk": "DiscoveryGuildCard.module__icon___TWg5Xz",
  "rf": "DiscoveryGuildCard.module__body___TWg5Xz",
  "$": "DiscoveryGuildCard.module__titleRow___TWg5Xz",
  "fh": "DiscoveryGuildCard.module__nameText___TWg5Xz",
  "h_": "DiscoveryGuildCard.module__description___TWg5Xz",
  "qr": "DiscoveryGuildCard.module__footer___TWg5Xz",
  "dJ": "DiscoveryGuildCard.module__stat___TWg5Xz",
  "gW": "DiscoveryGuildCard.module__statDot___TWg5Xz",
  "rR": "DiscoveryGuildCard.module__statDotOnline___TWg5Xz" + " " + "DiscoveryGuildCard.module__statDot___TWg5Xz",
  "rb": "DiscoveryGuildCard.module__statDotMembers___TWg5Xz" + " " + "DiscoveryGuildCard.module__statDot___TWg5Xz",
  "KA": "DiscoveryGuildCard.module__statText___TWg5Xz",
};

module.exports = exports;
